export const SetupsUsersTypesEnums = {
  Admins: {
    key: 1,
    value: "admins",
    valueSingle: "admin",
  },
  Employees: {
    key: 2,
    value: "employees",
    valueSingle: "employee",
  },
  Agency: {
    key: 3,
    value: "agencies",
    valueSingle: "agency",
    userType: "agency",
  },
  University: {
    key: 4,
    value: "universities",
    valueSingle: "university",
    userType: "university",
  },
};
